import React from 'react';
import { Link } from 'react-router-dom';
import { navConfig } from '../NavComponent/navConfig';
import styles from './RoleHome.module.css';

export default function RoleHome({ role }) {
  const config = navConfig.find(r => r.key === role);
  if (!config) return <p>Неизвестная роль: {role}</p>;

  const { label, icon, description, sections = [] } = config;

  return (
    <div className={styles.roleHome}>
      {/* Заголовок */}
      <div className={styles.header}>
        <i className={`bi ${icon} ${styles.icon}`} />
        <h1>{label}</h1>
        {description && <p className={styles.subtitle}>{description}</p>}
      </div>

      {/* Разделы */}
      {sections.length ? (
        sections.map((section, idx) => (
          <div key={idx} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <div className={styles.cards}>
              {section.items.map(item => (
                <Link key={item.to} to={item.to} className={styles.card}>
                  <i className={`bi ${item.icon}`} />
                  <div className={styles.cardText}>
                    <h4>{item.label}</h4>
                    {item.description && <p className={styles.desc}>{item.description}</p>}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className={styles.empty}>Разделы пока не добавлены.</p>
      )}
    </div>
  );
}
